import { render, staticRenderFns } from "./TagEditionModal.vue?vue&type=template&id=036db1a8&scoped=true"
import script from "./TagEditionModal.vue?vue&type=script&lang=js"
export * from "./TagEditionModal.vue?vue&type=script&lang=js"
import style0 from "./TagEditionModal.vue?vue&type=style&index=0&id=036db1a8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036db1a8",
  null
  
)

export default component.exports